import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { Connection } from "stores/ConnectionStore";

export default function GoogleSheetConnectedExtraConnectionDetails(
  connection: Connection
) {
  return (
    <Box>
      <a
        href={connection.config.url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none" }}
      >
        <Button variant="text">Link to sheet</Button>
      </a>
    </Box>
  );
}
